import script from "./form.vue?vue&type=script&setup=true&lang=js"
export * from "./form.vue?vue&type=script&setup=true&lang=js"

import "./form.vue?vue&type=style&index=0&id=b1828418&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1828418"]])

export default __exports__